import { useState } from 'react';
import useGeolocationPermission from './useGeolocationPermission';
import { GEOLOCATION_PERMISSION } from '../utils/constants';
import { useParams } from 'react-router-dom';

const useGpsGuard = () => {
  const { type } = useParams();
	const { permission } = useGeolocationPermission();
	const [isShowGpsSheet, setIsShowGpsSheet] = useState(false);

	const checkGps = (callback) => {
		if (permission !== GEOLOCATION_PERMISSION.GRANTED && type === "delivery") {
			setIsShowGpsSheet(true);
			return;
		}

		callback?.();
	};

	const onClose = () => {
		setIsShowGpsSheet(false);
	};

	return {
		checkGps,
		isShowGpsSheet,
		onClose,
	};
};

export default useGpsGuard;
